/**
 * Lightbox for DADDL PDP extra tiles. Shell is <daddl-overlay>.
 * Opens on tile click; arrows, swipe, and Escape move or close.
 * Overlay is portaled to document.body so sticky PDP/header
 * transforms cannot trap position:fixed under the header.
 * Not a scrollLeft carousel — slides toggle visibility.
 */
if (!customElements.get('daddl-pdp-lightbox')) {
  customElements.define(
    'daddl-pdp-lightbox',
    class DaddlPdpLightbox extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('daddl-overlay');
        this.slides = Array.from(this.querySelectorAll('[data-lightbox-slide]'));
        if (!this.overlay || !this.slides.length) return;

        this.index = 0;
        this.onOpen = this.onOpen.bind(this);
        this.onPrev = this.onPrev.bind(this);
        this.onNext = this.onNext.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.querySelectorAll('[data-lightbox-open]').forEach((button) => {
          button.addEventListener('click', this.onOpen);
        });
        this.querySelector('[data-lightbox-prev]')?.addEventListener('click', this.onPrev);
        this.querySelector('[data-lightbox-next]')?.addEventListener('click', this.onNext);

        this.stage = this.querySelector('[data-lightbox-stage]');
        if (this.stage) {
          this.stage.addEventListener('touchstart', this.onTouchStart, { passive: true });
          this.stage.addEventListener('touchend', this.onTouchEnd, { passive: true });
        }
        this.overlay.addEventListener('daddl-overlay:close', () => {
          document.removeEventListener('keydown', this.onKey);
        });
        document.body.append(this.overlay);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        this.overlay?.remove();
      }

      onOpen(event) {
        const key = event.currentTarget.getAttribute('data-lightbox-open');
        const next = this.slides.findIndex((slide) => slide.getAttribute('data-lightbox-slide') === key);
        this.show(next < 0 ? 0 : next);
        this.overlay.open();
        document.addEventListener('keydown', this.onKey);
      }

      onPrev() {
        this.show(this.index <= 0 ? this.slides.length - 1 : this.index - 1);
      }

      onNext() {
        this.show(this.index >= this.slides.length - 1 ? 0 : this.index + 1);
      }

      onKey(event) {
        if (!this.overlay.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.onPrev();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.onNext();
        }
      }

      onTouchStart(event) {
        this.touchX = event.touches[0].clientX;
        this.touchY = event.touches[0].clientY;
      }

      onTouchEnd(event) {
        if (this.touchX == null) return;
        const dx = event.changedTouches[0].clientX - this.touchX;
        const dy = event.changedTouches[0].clientY - this.touchY;
        this.touchX = null;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx > 0) this.onPrev();
        else this.onNext();
      }

      show(index) {
        this.index = index;
        this.slides.forEach((slide, i) => {
          slide.toggleAttribute('hidden', i !== index);
        });
      }
    }
  );
}
